var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7147_153738",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 22,
    height: 22
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 21,
    height: 21,
    rx: 3,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7147_153738)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9685 0.804932H-2.98389V23.9999H26.9685V0.804932Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.469367 23.6381C0.492478 23.6297 0.517874 23.6297 0.540985 23.6381C0.540985 23.6381 2.68157 22.0645 5.23596 20.1605L9.87523 16.6907V20.129C9.87523 22.4107 9.87523 23.6067 9.87523 23.6067C9.87523 23.6067 8.28371 23.6067 5.10068 23.6067C1.91765 23.6067 0.453451 23.6617 0.469367 23.6381Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2441 23.638C14.2441 23.638 14.2441 22.4421 14.2839 20.1603V16.6591L18.9391 20.1289C21.4935 22.0408 23.6182 23.6065 23.642 23.6065C23.6533 23.6015 23.6655 23.5989 23.6779 23.5989C23.6902 23.5989 23.7024 23.6015 23.7137 23.6065C23.7137 23.6065 22.1221 23.6065 18.9391 23.6065C15.7561 23.6065 14.2441 23.6616 14.2441 23.638Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.98389 17.9731C-2.98389 15.7307 -2.98389 14.5741 -2.98389 14.5741C-2.98389 14.5741 -1.55152 14.5741 1.2018 14.6134H5.4432L1.26546 17.9573C-1.03428 19.7749 -2.91227 21.2777 -2.92023 21.3013C-2.91352 21.319 -2.91352 21.3386 -2.92023 21.3563C-2.92023 21.3563 -2.98389 20.2391 -2.98389 17.9731Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9286 21.1047C26.9286 21.0653 25.162 19.6019 23.0373 17.8473L19.1699 14.6529H22.9975C25.9896 14.6529 26.8649 14.6529 26.8808 14.6057C26.8808 14.6057 26.8967 14.5585 26.8808 14.6057C26.8808 14.6057 26.8808 16.1006 26.8808 17.9024C26.8808 19.7042 26.9763 21.1362 26.9286 21.1047Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.98389 5.92719V2.54395L-2.86452 2.66197L1.33708 6.00587L5.41137 9.23176H1.24955C-1.49582 9.23176 -2.92023 9.23176 -2.92023 9.2711C-2.92023 9.2711 -2.98389 8.16958 -2.98389 5.92719Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9127 9.27899C26.9127 9.27899 25.5917 9.23965 23.0533 9.23965H19.1938L23.0533 6.01376C25.178 4.23559 26.9127 2.76427 26.9127 2.74067C26.9123 2.72226 26.9185 2.70431 26.9301 2.68993C26.9418 2.67555 26.9581 2.66567 26.9764 2.66199C26.9764 2.66199 26.9764 3.75564 26.9764 5.96656C26.9764 8.17747 26.9764 9.28686 26.9764 9.28686L26.9127 9.27899Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.57841 4.07817C3.21501 2.28426 1.24153 0.805076 1.19378 0.797208C1.15494 0.793317 1.11853 0.776701 1.09033 0.75C1.09033 0.75 3.00015 0.75 5.51475 0.75C8.4511 0.75 9.94712 0.75 9.94712 0.75C9.94712 0.75 9.94712 1.883 9.94712 4.03096V7.38274L5.57841 4.07817Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2915 4.0782C14.2915 1.90662 14.2915 0.781494 14.2915 0.781494C14.2915 0.781494 15.7955 0.781494 18.7478 0.781494C21.7 0.781494 23.1881 0.781494 23.1801 0.781494C23.1722 0.781494 23.1324 0.781494 23.1006 0.781494C23.0687 0.781494 15.143 6.73759 14.4745 7.27261L14.2915 7.38276V4.0782Z",
    fill: "#26336C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.84863 23.7168C-2.79293 23.7168 -0.166923 21.6475 2.98428 19.1848L8.71374 14.7079H9.87555V15.8015L4.6315 19.7356C1.75085 21.9071 -0.612548 23.6696 -0.60459 23.7089C-0.998053 23.7542 -1.39462 23.7674 -1.79027 23.7482C-2.9282 23.7718 -2.96004 23.7718 -2.84863 23.7168Z",
    fill: "#E52520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8379 18.6733V13.5749H3.94659H-2.95264V12.0406V10.5063H3.94659H10.8379V5.6675V0.820801H12.1509H13.4639V5.6675V10.5063H20.2358H26.9997V12.0406V13.5749H20.2358H13.4639V18.6733V23.7718H12.1509H10.8379V18.6733Z",
    fill: "#E52520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8805 23.5279C26.8805 23.4886 24.3341 21.5216 21.3102 19.1455L15.6842 14.7708C15.6285 14.7079 15.6842 14.7079 16.8142 14.7079H18.0078L22.4561 18.3114C24.8991 20.2942 26.9124 21.915 26.9203 21.9071C26.9283 21.8993 26.976 21.9937 26.9681 22.7883C26.9601 23.583 26.9283 23.5909 26.8805 23.5279Z",
    fill: "#E52520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.79047 5.62816C-0.803706 3.56674 -2.93634 1.87512 -2.95225 1.87512C-2.96817 1.87512 -2.95225 1.73349 -3 1.34009V0.820801H-2.63395C-2.41114 0.820801 -2.2679 0.820801 -2.2679 0.868009C-2.2679 0.915217 0.159161 2.80354 3.15121 5.11674C6.14327 7.42994 8.5942 9.34187 8.60216 9.3576C8.61012 9.37334 8.14062 9.3576 7.55176 9.3576H6.4934L1.79047 5.62816Z",
    fill: "#E52520"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2442 9.35767C14.235 9.22669 14.235 9.09524 14.2442 8.96427V8.5866L19.0745 4.77848C21.7243 2.66198 23.9286 0.946756 23.9684 0.899548L24.032 0.828735H25.2893C26.5228 0.828735 26.5546 0.828735 26.4432 0.883812C26.3318 0.938888 23.9047 2.84295 20.9365 5.15615L15.5413 9.38127H14.9047C14.6843 9.38979 14.4635 9.3819 14.2442 9.35767Z",
    fill: "#E52520"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnFlag);
export default __webpack_public_path__ + "static/media/en-flag.3b60377e88213c2bac2805ed33f91838.svg";
export { ForwardRef as ReactComponent };